import type { ReactNode } from 'react';
import React, { createContext } from 'react';

interface HttpClientContext {
  headers?: Record<string, string>;
}

export const HttpClientContext = createContext<HttpClientContext | null>(null);

interface HttpClientProviderProps {
  children: ReactNode;
  headers?: Record<string, string>;
}

export const HttpClientProvider = ({
  children,
  headers,
}: HttpClientProviderProps) => {
  return (
    <HttpClientContext.Provider value={{ headers }}>
      {children}
    </HttpClientContext.Provider>
  );
};
